import { FC, ReactElement } from 'react';
import ErrorLayout from '../../Layout/ErrorLayout';
import { IconButton } from 'rsuite';
import ArrowLeftLine from '@rsuite/icons/ArrowLeftLine';

const Error500: FC = (): ReactElement => (
  <ErrorLayout code={500}>
    <p className="error-page-title">Oops… You just found an error page</p>
    <p className="error-page-subtitle text-muted ">
      We are sorry but the page you are looking for was not found
    </p>
    <IconButton icon={<ArrowLeftLine />} appearance="primary" href="/">
      Take me home
    </IconButton>
  </ErrorLayout>
);

export default Error500;
